import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="container-page flex min-h-[62vh] flex-col items-center justify-center py-16 text-center">
      <span className="text-[11px] uppercase tracking-[0.3em] text-accent-500">404</span>
      <h1 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">
        这个页面不在这里
      </h1>
      <p className="mt-3 max-w-md text-[13px] leading-relaxed text-foreground-500">
        你访问的地址可能已经变更或被移除：<span className="text-foreground-700">{location.pathname}</span>
        。可以从下面的入口重新开始浏览。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-2.5">
        <Link
          to="/"
          className="rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          回到首页
        </Link>
        <Link
          to="/video-category"
          className="rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-accent-500 hover:text-accent-500 whitespace-nowrap"
        >
          浏览视频
        </Link>
        <Link
          to="/search"
          className="rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-accent-500 hover:text-accent-500 whitespace-nowrap"
        >
          站内搜索
        </Link>
      </div>
    </div>
  );
}